import React, { Component } from "react";
import { Link } from "react-router-dom";
import TableDec2020P from "./tables2020/TableDec2020P";
import TableNov2020P from "./tables2020/TableNov2020P";
import TableOct2020P from "./tables2020/TableOct2020P";
import TableSep2020P from "./tables2020/TableSep2020P";
import TableAgo2020P from "./tables2020/TableAgo2020P";
import TableJul2020P from "./tables2020/TableJul2020P";
import TableJun2020P from "./tables2020/TableJun2020P";
import TableMay2020P from "./tables2020/TableMay2020P";
import TableApr2020P from "./tables2020/TableApr2020P";
import TableMar2020P from "./tables2020/TableMar2020P";
import TableJan2021P from "./tables2021/TableJan2021P";
import TableFeb2021P from "./tables2021/TableFeb2021P";
import TableDec2021P from "./tables2021/TableDec2021P";
import TableNov2021P from "./tables2021/TableNov2021P";
import TableOct2021P from "./tables2021/TableOct2021P";
import TableSep2021P from "./tables2021/TableSep2021P";
import TableMay2021P from "./tables2021/TableMay2021P";
import TableApr2021P from "./tables2021/TableApr2021P";
import TableMar2021P from "./tables2021/TableMar2021P";
import TableAgo2021P from "./tables2021/TableAgo2021P";
import TableJul2021P from "./tables2021/TableJul2021P";
import TableJun2021P from "./tables2021/TableJun2021P";

export default class TablesP extends Component {
  render() {
    return (
      <>
        <div className="row my-4">
          <div className="col-md-12">
            <div className="nav py-3 border-bottom-gray">
              <div className="tabs">
                <Link to="/" className="tab ">
                  Pima Daily
                </Link>
                <Link to="/arizona" className="tab tab-inactive">
                  Arizona Daily
                </Link>
                <Link to="/pima-weekly" className="tab tab-inactive">
                  Pima Weekly
                </Link>
                <Link to="/arizona-weekly" className="tab tab-inactive">
                  Arizona Weekly
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableDec2021P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableNov2021P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableOct2021P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableSep2021P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableAgo2021P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableJul2021P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableJun2021P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableMay2021P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableApr2021P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableMar2021P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableFeb2021P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableJan2021P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableDec2020P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableNov2020P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableOct2020P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableSep2020P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableAgo2020P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableJul2020P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableJun2020P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableMay2020P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableApr2020P />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <TableMar2020P />
          </div>
        </div>
      </>
    );
  }
}
